<template>
    <Loading v-if="is_loading" class="static" />


    <div class="people-content" v-else :key="post.id">
        <Close @click.native="$router.push('/all-people')" />

        <div class="inner">
            <header class="people-header">
                <h2 v-html="post.title.rendered +'<br>'+ post.year"></h2>
                <span v-if="next_post_url"><Link :post_link="next_post_url">→ Next person</Link></span>
            </header>
        </div>
        <div class="people-gallery" v-if="gallery.images && gallery.images.length !== 0">
            <Slideshow :data="gallery" />
        </div>

        <div class="inner">
            <Content>
                <div class="box" v-html="content"></div>
            </Content>
        </div>

        <RelatedItems v-if="post.related_posts && post.related_posts.length !== 0" :items="post.related_posts" />
    </div>


</template>

<script>
import GetPreviewUrl from '@/utils/GetPreviewUrl';
import RelatedItems from '@/components/RelatedItems.vue';
import Content from '@/components/ui/Content.vue';
import Link from '@/components/ui/Link.vue';
import Loading from '@/components/Loading.vue';
import Close from '@/components/ui/Close.vue';
import Slideshow from '@/components/sections/SlideshowBlock.vue';

export default {
    name: 'single-people',
    props: {
        slug: {
            type: String,
            default: ''
        }
    },

    data () {
        return {
            post: false,
            content: '',
            is_loading: false,
            next_post_url: false,
            gallery: {
                images: [],
            },
        }
    },

    components: {
        RelatedItems,
        Content,
        Loading,
        Slideshow,
        Close,
        Link,
    },

    watch: {
        '$route.params': {
            handler(params) {
                // console.log(this.$route.name);
                this.fetchData(params);
            },
            immediate: true,
        }
    },

    methods: {
        fetchData() {
            this.is_loading = true;
            this.gallery.images = [];
            this.next_post_url =  '';
            let api_obj = GetPreviewUrl('peoples', this.slug);
            this.$ajax.get(api_obj.url, api_obj.head).then(res => {
                document.title = 'Charleston — ' + this.decode(res.data[0].title.rendered);
                this.post = res.data[0];
                this.content = this.post.content.rendered;
                this.is_loading = false;
                this.gallery.images = this.post.gallery;
                
                
                this.$ajax.get(`/get-posts/people`).then(r => {
                    r.data.forEach((o, index) => {
                        // console.log(o.ID , this.post.id)
                        let inx = (index + 1);
                        if (o.ID === this.post.id && inx !== r.data.length) {
                            // console.log(r.data[inx].post_name)
                            this.next_post_url = '/people/' + r.data[inx].post_name;
                        }
                    });
                });
            });
        },

    },
}
</script>
<style lang="scss">
    @import "@/assets/sass/variable";

    body.page-single-people {
        @include black-styles;
        @include hide-logo-navi;
    }

    .people-content {
        padding: 0 0 var(--padding) 0;


        .people-header {
            padding: var(--padding) 0;
            display: flex;
            font-size: var(--medium-size);

            h2 {
                flex: 1;
            }
        }

        .slideshow-block .swiper-container {
            background: black;
        }

        .image {
            display: block;

            img {
                display: block;
                width: 100%;
                height: auto;
            }

            figcaption {
                margin: var(--padding-50) 0 var(--padding-x2);
                font-size: var(--small-size);
            }
        }

        .box {
            iframe {
                width: 100%;
                overflow: hidden;
                height: 160px;
                margin: 3rem 0 0;
                display: block;
            }
        }

        .post-item {
            color: black;

            a:visited, 
            a:active,
            a {
                color: black;
            }
        }

        .related-items {
            background: var(--dark-gray);

            .related-title {
                color: white;
            }
        }
    }
    @media only screen and (max-width: 767px) {

        .people-header {
            display: block;
            text-align: center;
            padding: 0 var(--pading-x2);
            span {
                display: none;
            }
        }

        .people-content {
            .image figcaption {
                font-size: var(--tiny-size);
                line-height: 1.2;
            }
        }
    }

</style>

